import _ from 'lodash';
//import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';

import BulkInvoiceContainer from "../../containers/accounting/BulkInvoice";
import BulkInvoiceForPdf from "../../components/BulkInvoiceForPdf";

const styles = () => {
	return {
		root : {
			position : 'absolute',
			backgroundColor : 'white',
			height: '100%',
			width : '100%',
		},
	};
};

class BulkInvoice extends Component {

	constructor(props){
		super(props);
		const bulkInvoiceId = _.get(this.props, ['match', 'params', 'bulkInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			bulkInvoiceId : (bulkInvoiceId) ? parseInt(bulkInvoiceId, 10) : undefined,
			securityHash,
			errors : [],
		};
	}

	componentDidMount () {
		//- Only used for updates
		const { publicGetBulkInvoice, bulkInvoice} = this.props;
		const { bulkInvoiceId, securityHash } = this.state;
		if (bulkInvoice) { return; }

		publicGetBulkInvoice({
			params : {
				bulkInvoiceId,
				securityHash,
				includeQuickbooksCustomers : true,
				includeQuickbooksTerms : true,
			},
			callback : (err, r) => {
				if (err) { return this.setState({ errors : [err] }); }
				const bulkInvoice = _.get(r, ['collections', 'bulkInvoiceCollection', 0]);
				if (!bulkInvoice) { return {errors : ['Missing bulk invoice.']}; }
				return this.setState({ bulkInvoice });
			}
		});
	}

	render() {
		const {
			classes,
			bulkInvoice,
			quickbooksCustomerMap,
			bulkCustomerMap,
			quickbooksTermMap,
			terminalMap,
		} = this.props;

		const {
			errors,
		} = this.state;

		if (errors.length) {
			return (<div>
				<div>Encountered an error when retrieving the invoice</div>
				{errors.map((error,i) => {
					return (<div key={i}>{error}</div>);
				})};
			</div>);
		}

		if (!bulkInvoice) {
			return (<div>Fetching bulk invoice...</div>);
		}

		return (<div className={classes.root}>
			<BulkInvoiceForPdf
				bulkInvoice={bulkInvoice}
				quickbooksCustomerMap={quickbooksCustomerMap}
				quickbooksTermMap={quickbooksTermMap}
				bulkCustomerMap={bulkCustomerMap}
				terminalMap={terminalMap}
			/>
		</div>);
	}
}

BulkInvoice.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors : PropTypes.func,

	//- Batch
	publicGetBulkInvoice : PropTypes.func,
	bulkInvoice : PropTypes.object,
	quickbooksCustomerMap : PropTypes.object,
	quickbooksTermMap : PropTypes.object,
	bulkCustomerMap : PropTypes.object,
	terminalMap : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	BulkInvoiceContainer,
])(BulkInvoice);

